import React from 'react';
import { useBetting } from '../../context/BettingContext';
import TeamTag from '../shared/TeamTag';
import './Leaderboard.css';

export default function Leaderboard() {
  const { standings, snapshots, events, members = [] } = useBetting();
  const users = members;
  const displayName = entry => entry.teamId ? entry.name || entry.displayName : users.find(u => u.id === entry.userId)?.displayName || entry.name || entry.displayName || entry.userId;
  const activeEvent = events.find(e => e.status === 'active') || events.at(-1);
  const history = snapshots.filter(s => s.eventId === activeEvent?.id);
  return <div className="leaderboard">
    <h2>{standings.some(s => s.teamId) ? 'Team leaderboard' : 'Leaderboard'}</h2>
    <p>Standings use settled balances. Pending bets are shown separately.</p>
    <div className="lb-rankings">
      {!standings.length && <p>No participants have been assigned yet.</p>}
      {standings.map((entry, index) => <div className="lb-row" key={entry.id}>
        <span>{['🥇', '🥈', '🥉'][index] || index + 1}</span>
        <strong style={{ flex: 1, marginLeft: 14, color: entry.color }}>{displayName(entry)}{entry.userId && <TeamTag userId={entry.userId} />}</strong>
        <span style={{ marginRight: 18 }}>{entry.won} won · {entry.lost} lost · {entry.pending} pending</span>
        <strong>{entry.balance.toLocaleString()} coins</strong>
      </div>)}
    </div>
    <h3>Round results</h3>
    {!history.length && <p>Results appear when an admin concludes a fully settled round.</p>}
    {history.map(snapshot => <section className="lb-round" key={snapshot.id}>
      <h4>{snapshot.type === 'event_end' ? 'Final event results' : `Round ${snapshot.roundNumber}`}</h4>
      {snapshot.scores.map((entry, index) => <p key={entry.id || entry.teamId || entry.userId}>{index + 1}. {displayName(entry)} · {entry.balance} coins</p>)}
    </section>)}
  </div>;
}
